export default "__VITE_ASSET__Bw_7GaGa__"